import React from 'react';

interface DragHandleProps extends React.HTMLAttributes<HTMLSpanElement> {
    className?: string;
}

/**
 * Six-dot grip affordance used on every draggable/reorderable card (plan
 * board, triage panel, insight panels). Rendering the dot grid as SVG here
 * — rather than each card drawing its own Unicode glyph (⋮⋮, ⠿) — keeps the
 * affordance visually identical everywhere and avoids re-declaring it.
 *
 * Purely decorative when no mouse/click handlers are passed: PlanBoardCard,
 * for example, treats the whole card as the drag surface and renders this
 * only as a visual cue (its `.plan-board-card__drag-handle` modifier sets
 * `pointer-events: none`). Cards that use this as the actual drag trigger
 * (TriageCard, InsightCard, InsightPageCard) pass `onMouseDown`.
 */
export default function DragHandle({ className = '', title = 'Drag', ...rest }: DragHandleProps) {
    const classes = ['drag-handle', className].filter(Boolean).join(' ');
    return (
        <span className={classes} title={title} {...rest}>
            <svg viewBox='0 0 10 16' width='10' height='16' aria-hidden='true' focusable='false'>
                <circle cx='2.5' cy='2.5' r='1.4' />
                <circle cx='7.5' cy='2.5' r='1.4' />
                <circle cx='2.5' cy='8' r='1.4' />
                <circle cx='7.5' cy='8' r='1.4' />
                <circle cx='2.5' cy='13.5' r='1.4' />
                <circle cx='7.5' cy='13.5' r='1.4' />
            </svg>
        </span>
    );
}
